// Activity Log page — site-wide audit trail (/activity/all).
// Filters + pagination are server-side; this only drives the query string and
// swaps in the rendered rows partial.

let activityPage = 1;
let activitySearchTimer = null;

function activityFilters() {
    return {
        page: activityPage,
        search: $('#activitySearch').val() || '',
        entity_type: $('#activityEntityType').val() || '',
        action: $('#activityAction').val() || '',
        actor: $('#activityActor').val() || '',
        from_date: $('#activityFrom').val() || '',
        to_date: $('#activityTo').val() || ''
    };
}

function renderActivityPagination(data) {
    const container = $('#activityPagination');
    if (!container.length) return;
    if (data.total_pages <= 1) {
        container.empty();
        return;
    }

    const disabled = `<span class="inline-flex items-center justify-center w-9 h-9 rounded-md border border-slate-100 text-slate-300 text-sm cursor-not-allowed">`;
    const active = `<button class="inline-flex items-center justify-center w-9 h-9 rounded-md border border-slate-200 text-slate-600 hover:bg-slate-100 text-sm cursor-pointer activity-page-btn"`;

    let html = `<div class="flex flex-col sm:flex-row items-center justify-between mt-6 pt-4 border-t border-slate-200 gap-3">`;
    html += `<p class="text-sm text-slate-500">Showing page ${data.page} of ${data.total_pages} (${data.filtered_total} event${data.filtered_total !== 1 ? 's' : ''})</p>`;
    html += `<div class="flex items-center gap-1">`;
    if (data.has_prev) {
        html += `${active} data-page="1" title="First page"><i class="bi bi-chevron-double-left"></i></button>`;
        html += `${active} data-page="${data.page - 1}" title="Previous page"><i class="bi bi-chevron-left"></i></button>`;
    } else {
        html += `${disabled}<i class="bi bi-chevron-double-left"></i></span>`;
        html += `${disabled}<i class="bi bi-chevron-left"></i></span>`;
    }
    html += `<span class="inline-flex items-center justify-center w-9 h-9 rounded-md bg-blue-600 text-white text-sm font-medium">${data.page}</span>`;
    if (data.has_next) {
        html += `${active} data-page="${data.page + 1}" title="Next page"><i class="bi bi-chevron-right"></i></button>`;
        html += `${active} data-page="${data.total_pages}" title="Last page"><i class="bi bi-chevron-double-right"></i></button>`;
    } else {
        html += `${disabled}<i class="bi bi-chevron-right"></i></span>`;
        html += `${disabled}<i class="bi bi-chevron-double-right"></i></span>`;
    }
    html += `</div></div>`;
    container.html(html);
}

function fetchActivity() {
    const params = activityFilters();
    $('#activityList').css('opacity', 0.5);
    $.ajax({
        url: '/api/activity/fetch',
        method: 'GET',
        data: params
    }).done(function (response) {
        $('#activityList').html(response.html);
        $('#activityTotal').text(response.total);
        activityPage = response.page;
        renderActivityPagination(response);

        // Keep the URL shareable/back-button friendly.
        const qs = new URLSearchParams();
        Object.keys(params).forEach(function (k) {
            if (params[k] && !(k === 'page' && params[k] === 1)) qs.set(k, params[k]);
        });
        const url = qs.toString() ? `/activity/all?${qs.toString()}` : '/activity/all';
        window.history.replaceState({}, '', url);
    }).fail(function () {
        Toast.show('Failed to load activity log.', 'error', 3000);
    }).always(function () {
        $('#activityList').css('opacity', 1);
    });
}

// Any filter change restarts at page 1.
$(document).on('change', '#activityEntityType, #activityAction, #activityActor, #activityFrom, #activityTo', function () {
    activityPage = 1;
    fetchActivity();
});

$(document).on('input', '#activitySearch', function () {
    clearTimeout(activitySearchTimer);
    activitySearchTimer = setTimeout(function () {
        activityPage = 1;
        fetchActivity();
    }, 350);
});

$(document).on('click', '#activityReset', function () {
    $('#activitySearch').val('');
    $('#activityEntityType, #activityAction, #activityActor').val('');
    $('#activityFrom, #activityTo').val('');
    activityPage = 1;
    fetchActivity();
});

$(document).on('click', '.activity-page-btn', function () {
    activityPage = parseInt($(this).data('page'), 10) || 1;
    fetchActivity();
    $('html, body').animate({ scrollTop: $('#activityList').offset().top - 100 }, 200);
});

// Restore filter state from the URL on load (the server already rendered page 1
// unfiltered, so only re-fetch when the URL actually carries filters).
if (window.location.pathname.startsWith('/activity')) {
    const params = new URLSearchParams(window.location.search);
    if (params.toString()) {
        $('#activitySearch').val(params.get('search') || '');
        $('#activityEntityType').val(params.get('entity_type') || '');
        $('#activityAction').val(params.get('action') || '');
        $('#activityActor').val(params.get('actor') || '');
        $('#activityFrom').val(params.get('from_date') || '');
        $('#activityTo').val(params.get('to_date') || '');
        activityPage = parseInt(params.get('page'), 10) || 1;
        fetchActivity();
    }
}
